import { useState, useEffect, useRef } from 'react';
import { portfolios } from '../../../mocks/portfolios';
import PortfolioModal from '../../../components/feature/PortfolioModal';

export default function PortfolioSection() {
  const [visibleCards, setVisibleCards] = useState<boolean[]>(new Array(6).fill(false));
  const [selectedPortfolio, setSelectedPortfolio] = useState<typeof portfolios[0] | null>(null);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            portfolios.slice(0, 6).forEach((_, index) => {
              setTimeout(() => {
                setVisibleCards((prev) => {
                  const newState = [...prev];
                  newState[index] = true;
                  return newState;
                });
              }, index * 150);
            });
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section ref={sectionRef} id="portfolio" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">포트폴리오</h2>
            <p className="text-gray-600 text-lg">
              다양한 산업 분야에서 성공적으로 완료한 프로젝트들을 만나보세요
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {portfolios.slice(0, 6).map((portfolio, index) => (
              <div
                key={portfolio.id}
                onClick={() => setSelectedPortfolio(portfolio)}
                className={`bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-100 hover:shadow-xl hover:border-neon-pink/30 transition-all duration-500 hover:-translate-y-2 cursor-pointer group ${
                  visibleCards[index] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
              >
                <span className="inline-block px-3 py-1 bg-neon-pink/10 text-neon-pink text-xs font-semibold rounded-full mb-4 group-hover:bg-neon-pink group-hover:text-white transition-colors">
                  {portfolio.category}
                </span>
                <h3 className="text-xl font-bold mb-3 group-hover:text-neon-pink transition-colors">
                  {portfolio.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {portfolio.description}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <a
              href="/portfolio"
              className="inline-block bg-gray-900 text-white px-8 py-3 rounded-full font-semibold hover:bg-neon-pink hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
            >
              전체 포트폴리오 보기
            </a>
          </div>
        </div>
      </section>

      <PortfolioModal
        portfolio={selectedPortfolio}
        onClose={() => setSelectedPortfolio(null)}
      />
    </>
  );
}
